import { FullMarketplaceItem, conditionLabels } from 'model';
import { PostTypeViewProps } from './types.js';
import { PostTitle } from '../PostTitle.js';
import { PostHeader } from '../PostHeader.js';
import { filterInlineImages } from '../../util/filterInlineImages.js';
import { BigImageContainer } from '../BigImageContainer.js';
import { LinkPreviewComponent } from '../LinkPreviewComponent.js';
import { PostContentsSummary } from '../PostContentsSummary.js';
import { Price } from '../Price.js';
// eslint-disable-next-line css-modules/no-unused-class
import postStyles from '../../styles/posts.module.css';
import styles from './MarketplaceItemView.module.css';
import { IconCheckCircle } from '../QuirkIcons/index.js';
import { useCurrentUser } from '../../hooks/useCurrentUser.js';
import { useUpdateMarketplaceItemClosedMutation } from '../../api/PostApi.js';
import { IonButton } from '@ionic/react';

export function MarketplaceItemView({
	post,
	detail,
	preview,
	expanded,
	testId
}: PostTypeViewProps<FullMarketplaceItem>) {
	const [updateMarketplaceItemClosed] = useUpdateMarketplaceItemClosedMutation();

	const marketplaceAction = () => {
		updateMarketplaceItemClosed({ postid: post._id, close: !post.closed });
	};

	const isAuthor = useCurrentUser()._id === post.author;

	let marketplaceItemClosedLabel = '';
	if (post.closed) {
		marketplaceItemClosedLabel = 'Relist this item';
	} else {
		if (post.price === 0) {
			marketplaceItemClosedLabel = "I've given this away";
		} else {
			marketplaceItemClosedLabel = "I've sold this";
		}
	}

	return (
		<>
			<PostHeader post={post} />
			<div className={styles.titleWrapper}>
				<PostTitle postId={post._id} className={styles.priceTitle}>
					{post.title}
				</PostTitle>
				<Price price={post.price} showFree testId={`PostPrice-${post._id}`} showDecimal={false} />
			</div>
			<div className={styles.details} data-testid={`PostCondition-${post._id}`}>
				<IconCheckCircle /> Condition: {conditionLabels[post.condition]}
			</div>
			{!preview && (
				<>
					<div className={postStyles.postBody} data-testid={testId}>
						{detail && post.images.length > 0 && (
							<BigImageContainer post={post} images={filterInlineImages(post.contents, post.images)} />
						)}
						<PostContentsSummary post={post} allowExpand={detail} expanded={expanded} />
						<LinkPreviewComponent linkPreview={post.linkPreview} />
						{!detail && post.images.length > 0 && (
							<BigImageContainer post={post} images={filterInlineImages(post.contents, post.images)} />
						)}
					</div>
					{isAuthor && (
						<div className={styles.toggleClosedWrapper}>
							<IonButton expand="block" fill="outline" onClick={marketplaceAction}>
								{marketplaceItemClosedLabel}
							</IonButton>
						</div>
					)}
				</>
			)}
		</>
	);
}
